import { merge } from 'lodash';

const config = {
  companies: {
    default: {
      theme: 'light',
      color: '#2962ff',
      clearTicketInterval: 5000,
    },
    nsoft: {
      brandName: 'Demo',
      brandId: 'f0a2c9ff-cbf7-417e-b9ec-867c27bbe9ca',
      mode: 'user',
      scanType: 'barcode',
      theme: 'dark',
      color: null,
      logo: null,
      language: 'en',
      clearTicketInterval: 50000,
      environment: 'production',
      multiBrand: true,
    },
    nsoftstaging: {
      brandName: 'Demo',
      brandId: 'b99752b3-443c-4c80-b559-945a95c4b805',
      mode: 'user',
      scanType: 'barcode',
      theme: 'dark',
      color: null,
      logo: 'https://storage.googleapis.com/chameleon-storage-dev/apps/a0021b2d-ba5c-4d9a-95cc-73d75cd11a17/assets/nsoftlogo.jpg',
      language: 'hr',
      clearTicketInterval: 50000,
      environment: 'test',
      multiBrand: true,
    },
  },
  languages: [
    {
      name: 'Croatian',
      value: 'hr',
    },
    {
      name: 'English',
      value: 'en',
    },
    {
      name: 'German',
      value: 'de',
    },
    {
      name: 'Romanian',
      value: 'ro',
    },
    {
      name: 'Serbian Latin',
      value: 'sr-Latn',
    },
    {
      name: 'Slovakian',
      value: 'sk',
    },
    {
      name: 'Slovenian',
      value: 'si',
    },
    {
      name: 'Turkish',
      value: 'tr',
    },
    {
      name: 'Czech',
      value: 'cs',
    },
    {
      name: 'Shqip',
      value: 'sq',
    },
    {
      name: 'Spanish',
      value: 'es',
    },
    {
      name: 'Français',
      value: 'fr',
    },
  ],
  brands: [
    {
      name: '12BET',
      value: '010e2175-9fbd-4360-a9d5-6ac49d26195a',
      countryCode: 'ME',
    },
    {
      name: 'BHPlay',
      value: 'f81925dd-e79e-4f91-bf28-3b7655f7e254',
      countryCode: 'BA',
    },
    {
      name: 'Bingo Bet 1x2',
      value: '6c78d15c-4421-40e7-92f0-4def495b1a18',
      countryCode: 'RO',
    },
    {
      name: 'Bingwabet',
      value: '129a6b99-bcb9-492b-8ab7-a4d1b26cbfb5',
      countryCode: 'TZ',
    },
    {
      name: 'BMK',
      value: '3c32df0e-54aa-4e05-95f1-e6d6b0575c40',
      countryCode: 'BA',
    },
    {
      name: 'CG Bet',
      value: '1fb57d18-5b17-45e5-b0ac-a96a48aa6713',
      countryCode: 'CM',
    },
    {
      name: 'Champion Betting',
      value: 'a2023ffc-3fd6-4bdd-b91b-31b640c61ee7',
      countryCode: 'RO',
    },
    {
      name: 'Eurolloto',
      value: 'cd68a324-d7bf-476e-b677-598972821377',
      countryCode: 'ME',
    },
    {
      name: 'FairPlay',
      value: '0cda45b1-06ba-4684-b265-46a1cc00652c',
      countryCode: 'BA',
    },
    {
      name: 'FavBet Romania',
      value: '2f3c3965-c710-4a3c-8616-41b9b7e1e49a',
      countryCode: 'RO',
    },
    {
      name: 'Hemingway',
      value: 'dc9b15d3-c2db-457a-86b4-9f71fd94ca01',
      countryCode: 'ME',
    },
    {
      name: 'Hemingway City Kvart',
      value: 'da74132f-ca2d-4259-a289-574e28917890',
      countryCode: 'ME',
    },
    {
      name: 'Hemingway Stari Aerodrom',
      value: '4c5e6060-07d2-4e5b-b9f6-8a3200e41c5c',
      countryCode: 'ME',
    },
    {
      name: 'Izi Paryaj',
      value: '1d9a58ae-9a22-4ed5-b5d2-4e9eb6664240',
      countryCode: 'HT',
    },
    {
      name: 'Las Vegas',
      value: '6c285348-6f31-4729-9af1-99664a8e5500',
      countryCode: 'TZ',
    },
    {
      name: 'Livebet 1x2',
      value: '86afd4cc-c0ab-4745-bf04-e8e7f10839f6',
      countryCode: 'RO',
    },
    {
      name: 'Powerbet',
      value: '18563d1c-7b9d-403c-af32-e1c285ca33e0',
      countryCode: 'RO',
    },
    {
      name: 'Realbet',
      value: '0def12a7-5b6a-4025-9112-e056811735a2',
      countryCode: 'RO',
    },
    {
      name: 'Šansabet',
      value: 'cd751873-96f7-45ad-994e-f7b98dfa926a',
      countryCode: 'ME',
    },
    {
      name: 'Senator',
      value: '92aaebf9-4fb3-4863-98ee-eb75e48fbf21',
      countryCode: 'RO',
    },
    {
      name: 'Sima Communication',
      value: '8370ebb8-1ef5-4ff1-9c6a-ff21039f0914',
      countryCode: 'LS',
    },
    {
      name: 'Sky Bet',
      value: '610a77b8-21b8-4184-bfc4-d406cb3fb70d',
      countryCode: 'ME',
    },
    {
      name: 'Sportbetchalenge',
      value: '3a87d60f-fffb-41c0-b3fa-b864f9d1b6d2',
      countryCode: 'RO',
    },
    {
      name: 'Sporting Bookmakers',
      value: 'f1874e1a-40fd-4d7a-9da1-1a1b3413cdc4',
      countryCode: 'ME',
    },
    {
      name: 'Expo',
      value: 'f0a2c9ff-cbf7-417e-b9ec-867c27bbe9ca',
      countryCode: 'BA',
    },
    {
      name: 'NSoft',
      value: 'b99752b3-443c-4c80-b559-945a95c4b805',
      countryCode: 'BA',
    },
    {
      name: 'NSoft 2',
      value: '87ec8189-2a01-4e69-b814-c918ebaf7e72',
      countryCode: 'BA',
    },
  ],
};

export default function getSettings() {
  const deployMap = {
    'nsoft-ticket-scanner.netlify.com': 'nsoft',
    'nsoft-ticket-scanner.pibet.net': 'nsoft',
    'staging.nsoft-ticket-scanner.netlify.com': 'nsoftstaging',
    'staging.nsoft-ticket-scanner.pibet.net': 'nsoftstaging',
  };

  // Keep the env. variable override for local env.
  const deployment = process.env.VUE_APP_DEPLOYMENT_NAME
    || deployMap[window.document.location.host];

  let settings;

  if (deployment && config.companies[deployment]) {
    settings = merge(config.companies.default, config.companies[deployment]);
  } else {
    settings = config.companies.default;
  }

  if (settings.multiBrand) {
    settings.brands = JSON.stringify(config.brands);
    delete settings.brandId;
    delete settings.brandName;
  }

  settings.languages = JSON.stringify(config.languages);

  return settings;
}
